import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92466742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_ForCon = _resolveComponent("ForCon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.key
      }, [
        _createVNode(_component_a_typography_title, { level: 1 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.title), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_ForCon, {
          data: item.children
        }, null, 8, ["data"])
      ], 64))
    }), 128))
  ]))
}